<template>
  <div class="booking-list">
    <MatterPageList :list="list">
      <template v-slot:list-prview="{ item }">
        <MatterBookingRow
          :booking="item"
          :section="section"
          :showStaff="isMultipleStaffs"
          @click="$emit('click', $event)" />
      </template>
    </MatterPageList>
    <InfiniteScroll
      @on-scroll="loadMore"
      :identifier="refreshId"
      :is-empty="isEmpty"
      :no-result-txt="$t('client.matters.matter_page.bookings_tab.no_items_found')" />
  </div>
</template>

<script>
import {InfiniteScroll} from "@/modules/common/components"
import MatterBookingRow from "@/modules/matters/components/matterBookingRow/MatterBookingRow"
import MatterPageList from '@/modules/matters/components/matterPageList/MatterPageList'

export default {
  name: "BookingList",
  components: {
    InfiniteScroll,
    MatterPageList,
    MatterBookingRow
  },
  props: {
    page: {
      type: String,
      required: true
    },
    listName: {
      type: String,
      required: true
    },
    setPage: {
      type: String,
      required: true
    },
    loadData: {
      type: String,
      required: true
    },
    getterCompleted: {
      type: String,
      required: true
    },
    section: {
      type: String,
      required: true
    },
    refreshId: {
      type: Number,
      required: true
    }
  },
  computed: {
    isMultipleStaffs() {
      return this.$store.getters['accountModule/isMultipleStaffs']
    },
    currContact() {
      return this.$store.getters['mattersModule/currContact']
    },
    list() {
      if (this.listName === 'pastBookings') {
        return this.$store.getters["mattersModule/" + this.listName].filter(item => item.state !== 'pending')
      }
      return this.$store.getters["mattersModule/" + this.listName]
    },
    currPage() {
      return this.$store.getters['mattersModule/' + this.page]
    },
    isCompleted() {
      return this.$store.getters['mattersModule/' + this.getterCompleted]
    },
    isEmpty(){
      return this.isCompleted && this.list.length === 0
    },
  },
  methods: {
    async loadMore($state) {
      const page = this.currPage
      this.$store.commit("mattersModule/" + this.setPage, page + 1)
      await this.$store.dispatch({type: "mattersModule/" + this.loadData, payload: {clientId: this.currContact.uid}})
      if (this.isCompleted) {
        $state.complete();
        return
      }

      $state.loaded();
    }
  }
}
</script>

<style lang="scss" scoped>
.booking-list {
  align-items: stretch;
  width: 100%;
  overflow: auto;
  flex: 1;
}
</style>
